export default __webpack_public_path__ + "static/media/portrait.d0ba1aa3.jpg";